const titleMap = {
  courses: 'Courses',
  units: 'Units of Competency',
  resources: 'Resources',
  home: 'Dashboard',
  users: 'Users',
  providers: 'Providers',
  analytics: 'Analytics',
  assessments: 'Assessments',
  sandbox: 'Sandbox',
};

export function getAdminTitle(currentPage) {
  let title = titleMap[currentPage] || '';
  if (title) {
    title += ' • ';
  }

  return title;
}
